import Layout from '@/components/layout-components/homeLayout/Layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import SubscriptionPromoPageContnet from '@/features/subscriptions/components/SubscriptionPromoPageContnet'
import { getMemebershipPackageDetails } from '@/utils/serverUtils'

export default function SubscriptionPromoPage(props) {
    return <SubscriptionPromoPageContnet Layout={Layout} checkMembershipOnClient {...props} />
}

export async function getStaticProps({ locale }) {
    const translations = await serverSideTranslations(locale, ['HomeLayout'])

    let membershipPackageDetails = null
    try {
        membershipPackageDetails = await getMemebershipPackageDetails()
    } catch (error) {
        console.error('Failed to fetch membership package details', error)
    }

    return {
        props: {
            ...translations,
            membershipPackageDetails,
        },
        revalidate: 900, 
    }
}
